'use client'

import React, { useState } from 'react'
import { Button } from '@/ui/shadcn/button'
import Link from 'next/link'
import { ChevronDownIcon } from 'lucide-react'
import ListFilter from './ListFilter'
import { sizeFilter, sortFilter, stateFilter } from '@/lib/constants/filters'
import ListFilterPrice from './ListFilterPrice'

export type ListHeaderProps = {
    title: string
    link: string
    filters: boolean
    datas: any
    updateFilters: (key: string, value: string) => void
}

export default function ListHeader({ title, link, filters, datas, updateFilters }: ListHeaderProps) {

    const [isFiltersOpen, setIsFiltersOpen] = useState(false)

    const colorFilter = datas?.colors?.map((color: any) => ({
        value: color.name,
        label: color.name,
    }))

    return (
        <div className="flex flex-col">
            <div className="flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
                <p className="text-4xl text-black font-alt">{title}</p>
                <div className="flex flex-col">
                    <div className="flex flex-row gap-4 w-full">
                        {filters && (
                            <>
                                <ListFilter 
                                    items={sortFilter} placeholder="TRIER" search={false} 
                                    action={(value) => updateFilters('sort', value)}
                                />
                                <Button size={'lg'} variant={'dark'} onClick={() => setIsFiltersOpen(!isFiltersOpen)}>
                                    FILTRER
                                </Button>
                            </>
                        )}
                        {link && (
                            <Link href={link} className="hidden lg:block">
                                <Button size={'lg'} variant={'outline'}>
                                        Voir tout les produits
                                </Button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            {isFiltersOpen && (
                <div className="flex flex-row items-center gap-4 w-full py-5">
                    <p>Filtrer par :</p>
                    <ListFilterPrice 
                        placeholder="Prix" 
                        action={(value) => updateFilters('price', value)} 
                    />
                    <ListFilter 
                        items={stateFilter} placeholder="État" search={false} 
                        action={(value) => updateFilters('state', value)}
                    />
                    <ListFilter 
                        items={sizeFilter} placeholder="Taille" search={false} 
                        action={(value) => updateFilters('size', value)} 
                    />
                    <ListFilter 
                        items={colorFilter} placeholder="Couleur" search={false} 
                        action={(value) => updateFilters('color', value)} 
                    />
                    {datas?.creators && datas.creators.length > 0 && (
                        <ListFilter 
                            items={datas.creators.map((creator: any) => ({
                                value: creator.id,
                                label: creator.name,
                            }))} 
                            placeholder="Créateur" 
                            search={true} 
                            action={(value) => updateFilters('creator', value)} 
                        />
                    )}
                </div>
            )}
        </div>
    )
}
